<template>
  <div class="retroPage">
    <Header :isRetroPage="true" :retro="retro" :saveRetroTitle="saveRetroTitle" :lockRetro="lockRetro" />
    <div class="center columns" v-if="allowedWorkspace && allowedRetro">
      <div class="column" v-for="(topicItem, index) in retro.topicMap" :key="topicItem.id">
        <div class="subtitle">{{ topicItem.title }}</div>
        <div class="newPointWrapper">
          <Mentionable_extended @open="onOpenMention" @close="onCloseMention" :keys="['@']" :items="membersForMention" offset="6">
            <input :disabled="retro.locked" tabindex="-1" type="text" placeholder="Write something..." v-model="newTopic[index]" @keyup.enter="addTalkingPoint(index)" />
          </Mentionable_extended>
          <button v-if="newTopic[index] && newTopic[index].length" @click="addTalkingPoint(index)"></button>
        </div>
        <div class="existedPointAll">
          <div v-bind:class="[retro.locked ? 'existedPoint_locked' : '', topicItem.allowVote ? '' : 'existedPoint_noVotes', 'existedPoint']" v-for="topic in getTopicData(index)" :key="topic.id">
            <pre v-html="topic.title"></pre>
            <Mentionable_extended @open="onOpenMention" @close="onCloseMention" :keys="['@']" :items="membersForMention" offset="6">
              <textarea :disabled="retro.locked" tabindex="-1" @blur="pointOnBlur({ topicMapId: index, topicId: topic.id, newTitle: topic.title, $event })" @keydown.esc.prevent="pointOnBlur({ topicMapId: index, topicId: topic.id, newTitle: topic.title, $event })" @keydown.enter.prevent="pointOnBlur({ topicMapId: index, topicId: topic.id, newTitle: topic.title, $event })" v-model="topic.title"></textarea>
            </Mentionable_extended>
            <button
              v-if="topicItem.allowVote"
              :disabled="retro.locked"
              v-bind:class="{ voted: checkIsVoted({ topicMapId: index, topicId: topic.id }) }"
              @click="
                voteClick({
                  topicMapId: index,
                  topicId: topic.id
                })
              "
            >
              + {{ topic.rate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db,{ ANALYTICS } from 'src/firebase-config';
import firebase from 'firebase/app';
import { mapState } from 'vuex';
import Header from '../elements/Header.vue';
import mixins from 'src/mixins.js';
import Mentionable_extended from '../../components/Mentionable_extended.vue';
import _orderBy from "lodash.orderby";

export default {
  components: { Header, Mentionable_extended },
  mixins: [mixins],
  props: {},
  data() {
    return {
      retro: {
        retroName: ' '
      },
      topics: {},
      allowSaveByEnter: true,
      allowedWorkspace: false,
      allowedRetro: false,
      retroListener: () => {},
      newTopic: {},
      voted: {}
    };
  },
  computed: {
    ...mapState(['userInfo', 'singleRetroLoaded', 'workspaces', 'userInfoLoaded', 'currentWorkspace', 'currentUser', 'members']),
    retroId: function () {
      return this.$router.currentRoute.params.retroId;
    },
    retroRef: function () {
      return db.collection('workspaces').doc(this.workspaceId).collection('retros').doc(this.retroId);
    },
    membersForMention: function () {
      const members = Object.values(this.members) || [];
      // filter himself
      // const filtered = members.filter((item) => {
      //   return !!item.name && item.id !== this.currentUser.uid;
      // });
      return members.map((item) => {
        return {
          value: item.name.replace(/ /g, '_'),
          label: item.name
        };
      });
    }
  },
  methods: {
    addTalkingPoint: function (index) {
      // return if menu opened
      if(!this.allowSaveByEnter) return;

      if (this.newTopic[index].trim() === '') return;
      this.retroRef
        .collection(String(index))
        .add({
          ...(this.retro.topicMap[index].allowVote && {
            rate: 1,
            votedUsers: [this.currentUser.uid]
          }),
          title: this.newTopic[index],
          lastUpdateUser:this.currentUser.uid
        })
        .then(() => {
          this.newTopic[index] = '';
        })
        .catch(function (error) {
          console.error('Error adding document: ', error);
        });
    },
    pointOnBlur({ topicMapId, topicId, newTitle, $event }) {
      const topicRef = this.retroRef.collection(String(topicMapId)).doc(topicId);
      if (newTitle === '') {
        topicRef.delete();
      } else {
        topicRef.update({
          title: newTitle,
          lastUpdateUser:this.currentUser.uid
        });
      }
      $event.target.blur();
    },
    voteClick({ topicMapId, topicId }) {
      const topicRef = this.retroRef.collection(String(topicMapId)).doc(topicId);
      if (this.checkIsVoted({ topicMapId, topicId })) {
        topicRef.update({
          rate: firebase.firestore.FieldValue.increment(-1),
          votedUsers: firebase.firestore.FieldValue.arrayRemove(this.currentUser.uid)
        });
      } else {
        topicRef.update({
          rate: firebase.firestore.FieldValue.increment(1),
          votedUsers: firebase.firestore.FieldValue.arrayUnion(this.currentUser.uid)
        });
      }
    },
    checkIsVoted({ topicMapId, topicId }) {
      return this.topics[topicMapId][topicId].votedUsers.includes(this.currentUser.uid);
    },
    userInfoCheck: function () {
      this.subscribeAllWorkspacesMixin();
    },
    workspacesCheck: function () {
      this.setCurrentWorkspaceMixin();
    },
    saveRetroTitle(event) {
      this.retroRef
        .update({
          retroName: event.target.value
        })
        .then(() => {
          event.target.blur();
          this.updatePageTitle();
        });
    },
    lockRetro() {
      if(!this.retro.locked){
        ANALYTICS.logEvent('retro_locked',{
          retroId: this.retroId
        });
      }

      this.retroRef.update({
        locked: !this.retro.locked
      });

    },
    updatePageTitle() {
      document.title = this.retro.retroName.trim() ? `${this.retro.retroName} - EZ Retro` : 'EZ Retro';
    },
    currentWorkspaceCheck: function () {
      if (!this.currentWorkspace) return;
      if (!this.currentWorkspace.id) return;
      const retroId = this.$router.currentRoute.params.retroId;
      this.retroListener = this.retroRef.onSnapshot((snapshot) => {
        if (!snapshot.exists) {
          this.$router.push('/404');
        } else {
          const retroData = snapshot.data();

          this.retro = {
            ...retroData
          };
          Object.values(retroData.topicMap).forEach((topic, index) => {
            this.retroRef.collection(topic.id).onSnapshot((snapshot2) => {
              const topic = snapshot2;
              const dataCollection = {};
              topic.forEach((topicItem) => {
                dataCollection[topicItem.id] = {
                  ...topicItem.data(),
                  id: topicItem.id
                };
              });
              this.$set(this.topics, index, dataCollection);
              this.allowedRetro = true;
            });
          });
        }
      });
    },
    onOpenMention (key) {
      this.allowSaveByEnter = false
    },
    onCloseMention (key) {
      setTimeout(()=>{
        this.allowSaveByEnter = true
      },200)
    },
    getTopicData(index){
      return this.topics[index] ? _orderBy(Object.values(this.topics[index]), ['rate'], ['desc']) : []
    },
  },
  mounted() {
    if(!this.currentUser){
      this.$router.push('/404');
    }

    ANALYTICS.logEvent('page_view');
  },
  beforeDestroy() {
    this.retroListener();
  }
};
</script>

<style scoped></style>
